import { Link } from '@atlassian/search-dialog';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { N500, N20, N30 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const MoreFiltersLink = styled(Link)({
	display: 'block',
	textAlign: 'center',
	borderRadius: '3px',
	color: token('color.text.subtle', N500),
	cursor: 'pointer',
	padding: token('space.075', '6px'),
	backgroundColor: token('color.background.neutral', N20),
	transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
	'&:hover': {
		color: token('color.text.subtle', N500),
		backgroundColor: token('color.background.neutral.hovered', N30),
		textDecoration: 'none',
		transition: 'background 0s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
	},
	'&:visited': {
		color: token('color.text.subtle', N500),
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const MoreFiltersContainer = styled.div({
	paddingTop: token('space.400', '28px'),
});
